import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { putDataPromise } from 'brock-fetch-utils';
import {
    HorizontalFlex,
    PadContainer,
    AnimatedLoader,
    PageActionMenu,
    Toggles,
    Toggle,
} from 'smartsuite-ui';
import { useLabelContext } from '../shared/hooks/labelContext';
import DashboardContext from '../shared/hooks/dashboardContext';

// eslint-disable-next-line complexity
export default function DashboardHeader(props) {
    const { dashboardLabels } = useLabelContext();
    const {
        uriConstants: { auditLogUri, pageHelpUri },
    } = useContext(DashboardContext);

    function renderViewToggles() {
        if (props.viewOptions.length === 1) {
            return null;
        }

        return (
            <div className="dashboard-header__toggles">
                <Toggles cssClassModifiers={['flex-wrap']}>
                    {props.viewOptions.map(({ viewKey, viewLabel }) => (
                        <Toggle
                            key={viewKey}
                            isActive={props.viewKey === viewKey}
                            onClick={() => {
                                if (!props.togglesDisabled) {
                                    props.setTogglesDisabled();
                                    props.onViewChange(viewKey);
                                }
                            }}
                        >
                            {viewLabel ?? dashboardLabels[viewKey] ?? viewKey}
                        </Toggle>
                    ))}
                </Toggles>
            </div>
        );
    }

    function onActionClick(description) {
        putDataPromise(auditLogUri, {
            message: `Page action selected on ${props.title}: ${description}.`,
        });
    }

    return (
        <div className="dashboard-header">
            <HorizontalFlex cssClassModifiers={['flex-wrap']}>
                <div className="dashboard-header__title-wrapper">
                    <HorizontalFlex cssClassModifiers={['flex-wrap']}>
                        <span className="dashboard-header__title">
                            {props.title}
                        </span>
                        {props.subtitle && (
                            <label className="label dashboard-header__subtitle">
                                {`(${props.subtitle})`}
                            </label>
                        )}
                    </HorizontalFlex>
                </div>
                {renderViewToggles()}
            </HorizontalFlex>
            <div className="dashboard-header__page-actions">
                {props.isMetricDataLoading && (
                    <PadContainer cssClassModifiers={['pad-medium']}>
                        <AnimatedLoader />
                    </PadContainer>
                )}
                {props.pageActions && (
                    <PageActionMenu
                        pageHelpUrl={pageHelpUri(props.onlineHelpId)}
                        pageActions={props.pageActions}
                        onActionClick={onActionClick}
                    />
                )}
            </div>
        </div>
    );
}

DashboardHeader.propTypes = {
    onViewChange: PropTypes.func.isRequired,
    isMetricDataLoading: PropTypes.bool,
    onlineHelpId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    pageActions: PropTypes.instanceOf(Array),
    setTogglesDisabled: PropTypes.func.isRequired,
    subtitle: PropTypes.string,
    title: PropTypes.string.isRequired,
    togglesDisabled: PropTypes.bool,
    viewKey: PropTypes.string.isRequired,
    viewOptions: PropTypes.instanceOf(Array).isRequired,
};

DashboardHeader.defaultProps = {
    isMetricDataLoading: false,
    onlineHelpId: undefined,
    pageActions: undefined,
    subtitle: '',
    togglesDisabled: false,
};
